export const defaultInput = [
	{
		name: 'personOrEntity',
		label: 'entities',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		type: 'radio',
		value: 0,
		items: [
			{
				valueType: 'number',
				value: 0,
				label: 'person',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
			{
				valueType: 'number',
				value: 1,
				label: 'entity',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			}
		],
		valueType: 'number',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'name',
		label: 'name',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'text',
		isActive: true,
		confirm: false,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'surname',
		label: 'surname',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'text',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'email',
		label: 'email',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'email',
		isActive: true,
		confirm: true,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'dni',
		label: 'dni',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'dni',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'phone',
		label: 'phone',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		placeholderSearchBarLabel: '', // TRADUCCION
		placeholderSearchBarText: {
			es: 'Busca prefijo o país',
			en: 'Search prefix or country',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'phone',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'initialState',
		label: 'participation_type',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'number',
		type: 'select',
		value: undefined,
		items: [
			{
				valueType: 'number',
				value: 0,
				label: 'viewer',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
			{
				valueType: 'number',
				value: 2,
				label: 'granted_word',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
			{
				valueType: 'number',
				value: 4,
				label: 'cant_ask_word',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
			{
				valueType: 'number',
				value: 3,
				label: 'waiting_room',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			}
		],
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'socialCapital',
		label: 'social_capital',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'number',
		type: 'number',
		value: undefined,
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'numParticipations',
		label: 'num_participations',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'number',
		type: 'number',
		value: undefined,
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'position',
		label: 'position',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'number',
		type: 'number',
		value: undefined,
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'language',
		label: 'language',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'select',
		value: 'es',
		items: [
			{
				valueType: 'text',
				value: 'es',
				label: 'Español',
				text: {},
			},
			{
				valueType: 'text',
				value: 'en',
				label: 'English',
				text: {},
			},
			{
				valueType: 'text',
				value: 'gal',
				label: 'Galego',
				text: {},
			},
			{
				valueType: 'text',
				value: 'cat',
				label: 'Catalá',
				text: {},
			},
			{
				valueType: 'text',
				value: 'eu',
				label: 'Euskera',
				text: {},
			},
			{
				valueType: 'text',
				value: 'fr',
				label: 'Français',
				text: {},
			},
			{
				valueType: 'text',
				value: 'pt',
				label: 'Português',
				text: {},
			},
			{
				valueType: 'text',
				value: 'pl',
				label: 'Polsku',
				text: {},
			}
		],
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false
	}
];

export const defaultRepresentativeInput = [
	{
		name: 'name',
		label: 'name',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'text',
		isActive: true,
		confirm: false,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'surname',
		label: 'surname',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'text',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'email',
		label: 'email',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'email',
		isActive: true,
		confirm: true,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'dni',
		label: 'dni',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'dni',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'phone',
		label: 'phone',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		placeholderSearchBarLabel: '', // TRADUCCION
		placeholderSearchBarText: {
			es: 'Busca prefijo o país',
			en: 'Search prefix or country',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'phone',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'language',
		label: 'language',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		type: 'select',
		value: 'es',
		items: [
			{
				valueType: 'text',
				value: 'es',
				label: 'Español',
				text: {},
			},
			{
				valueType: 'text',
				value: 'en',
				label: 'English',
				text: {},
			},
			{
				valueType: 'text',
				value: 'gal',
				label: 'Galego',
				text: {},
			},
			{
				valueType: 'text',
				value: 'cat',
				label: 'Catalá',
				text: {},
			},
			{
				valueType: 'text',
				value: 'eu',
				label: 'Euskera',
				text: {},
			},
			{
				valueType: 'text',
				value: 'fr',
				label: 'Français',
				text: {},
			},
			{
				valueType: 'text',
				value: 'pt',
				label: 'Português',
				text: {},
			},
			{
				valueType: 'text',
				value: 'pl',
				label: 'Polsku',
				text: {},
			}
		],
		valueType: 'text',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	}
];

export const defaultDelegateInput = [
	{
		name: 'name',
		label: 'name',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'text',
		isActive: true,
		confirm: false,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'surname',
		label: 'surname',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'text',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
	{
		name: 'email',
		label: 'email',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'email',
		isActive: true,
		confirm: true,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'dni',
		label: 'dni',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'dni',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: true,
	},
	{
		name: 'phone',
		label: 'phone',
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		placeholderSearchBarLabel: '', // TRADUCCION
		placeholderSearchBarText: {
			es: 'Busca prefijo o país',
			en: 'Search prefix or country',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
		valueType: 'text',
		type: 'phone',
		isActive: false,
		confirm: false,
		checkbbdd: false,
		required: false,
	},
];

export const defaultConfig = {
	sections: {
		home: {
			value: 'home',
			isActive: true,
			label: '',
			text: {
				es: 'Inicio', // TRADUCCION
				en: 'Home',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		access: {
			value: 'access',
			isActive: true,
			label: '',
			text: {
				es: 'Asistencia a la junta', // TRADUCCION
				en: 'Meeting attendance',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		representation: {
			value: 'representation',
			isActive: false,
			label: 'representation',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		delegation: {
			value: 'delegation',
			isActive: false,
			label: 'vote_delegation',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		earlyVote: {
			value: 'earlyVote',
			isActive: false,
			label: '',
			text: {
				es: 'Voto telemático', // TRADUCCION
				en: 'Telematic voting',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		interventions: {
			value: 'interventions',
			isActive: false,
			label: '',
			text: {
				es: 'Intervenciones', // TRADUCCION
				en: 'Interventions',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		documents: {
			value: 'documents',
			isActive: true,
			label: 'documents',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
	},
	header: {
		isActive: true,
		logo: '',
		logoIsActive: true,
		bgImage: 'https://api.dev.councilbox.com/static/img/portalBgImg.png',
	},
	home: {
		bgImage: 'https://api.dev.councilbox.com/static/img/portalBgImg.png',
		dateFormat: 'DD MMMM YYYY HH:mm[h]',
		button: {
			value: 'access',
			isActive: true,
			label: '',
			text: {
				es: 'Solicite su asistencia', // TRADUCCION
				en: 'Request your assistance',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		buttonOptions: {
			isActive: true,
			label: '',
			text: {
				es: 'Más opciones', // TRADUCCION
				en: 'More options',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		highlighted: {
			dateFormat: 'DD/MM/YYYY',
			isActive: true,
			label: '',
			text: {
				es: 'Los accionistas deben comunicar su intención de asistencia a través del registro antes del {{councilCloseHour}} del dia {{councilCloseDay}}',
				en: 'Shareholders must communicate their intention to attend by registering before {{councilCloseHour}} on {{councilCloseDay}}',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		},
		information: {
			dateFormat: 'DD/MM/YYYY',
			isActive: true,
			label: '',
			text: {
				es: '<p><span class="font-bold"><strong>{{companyName}} realizar&aacute; su {{councilName}} el {{councilDate}}.</strong><br><br></span><span class="font-bold"><strong>Lugar de celebraci&oacute;n - {{councilStreet}}, {{councilCity}}.</strong><br><br></span><span class="text-justify">Los accionistas que deseen asistir mediante videoconferencia a la {{councilName}}, o sus representantes, deber&aacute;n registrarse previamente, a trav&eacute;s de la p&aacute;gina web de la Sociedad, hasta las 23:59 del d&iacute;a previo a la celebraci&oacute;n de la Junta.</span></p>',
				en: '<p><span class="font-bold"><strong>{{companyName}} will hold its {{councilName}} on {{councilDate}}.</strong><br><br></span><span class="font-bold"><strong>Vanue - {{councilStreet}}, {{councilCity}}.</strong><br></span></p><p><span class="text-justify">Shareholders who wish to attend the {{councilName}} by videoconference or their representatives, must register in advance, through the Company&apos;s website, until 11:59 p.m. on the day before the meeting is held.</span></p>',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		},
		documentation: {
			isActive: true,
			label: '',
			text: {
				es: 'Documentación',
				en: 'Documentation',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		},
		moreDocumentation: {
			isActive: true,
			label: '',
			text: {
				es: 'Más documentación',
				en: 'More documentation',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		},
		title: {
			isActive: true,
			label: '',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		},
		subTitle: {
			isActive: true,
			label: '',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		}
	},
	forms: {
		send: {
			label: 'send',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		attach: {
			label: '',
			text: {
				es: 'Adjuntar', // TRADUCCION
				en: 'Attach',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		participantData: {
			label: 'partner_data',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		representativeData: {
			label: '',
			text: {
				es: 'Datos del representante del socio persona jurídica', // TRADUCCION
				en: 'Data of the representative of the legal person partner',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		voteSense: {
			label: 'vote_sense',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		delegation: {
			label: '',
			text: {
				es: 'Datos del delegado',
				en: 'Delegate details',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		delegationCustom: {
			label: '',
			text: {
				es: 'Introducir datos manualmente',
				en: 'Enter data manually',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		delegationOtherPerson: {
			label: '',
			text: {
				es: 'Otra persona',
				en: 'Another person',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
			value: '',
		},
		representationOtherPerson: {
			label: '',
			text: {
				es: 'Otra persona',
				en: 'Another person',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
			value: '',
		},
		aditionalText: {
			label: '',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
			value: '',
		},
		aditionalTextTitle: {
			label: '',
			text: {
				es: 'Información adicional',
				en: 'Additional information',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
			value: '',
		},
		intervention: {
			label: '',
			text: {
				es: 'Intervención',
				en: 'Intervention',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
			value: '',
		},
		interventionTextarea: {
			value: '',
			name: 'intervention',
			label: '',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
			maxSize: 2000,
			valueType: 'text',
			type: 'textarea',
			isActive: true,
			confirm: false,
			checkbbdd: false,
			required: true,
		},
	},
	validation: {
		emptyError: {
			label: '',
			text: {
				es: 'El campo no puede estar vacío',
				en: 'The field cannot be empty',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		obligatoryError: {
			label: '',
			text: {
				es: 'Campo obligatorio',
				en: 'Obligatory field',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		optionError: {
			label: '',
			text: {
				es: 'El número de opciones debe de ser al menos ',
				en: 'The number of options must be at least ',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		confirmError: {
			label: '',
			text: {
				es: 'Los campos no coinciden',
				en: "The fields don't match",
				gal: '',
				cat: 'Els camps no coincideixen',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		maxLenghtError: {
			label: '',
			text: {
				es: 'El campo es demasiado largo',
				en: 'The field is too long',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		lettersFormatError: {
			label: '',
			text: {
				es: 'El campo solo puede contener letras',
				en: 'The field can only contain letters',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		lettersAndNumersFormatError: {
			label: '',
			text: {
				es: 'El campo debe contener letras o números',
				en: 'The field must contain letters or numbers',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		},
		formatError: {
			label: '',
			text: {
				es: 'El formato del campo no es válido',
				en: 'The field format is not valid',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			}
		}
	},
	popUps: {
		changeWindow: {
			information: {
				label: '',
				text: {
					es: '<p style="text-align: center;">&iexcl;Espere! Tiene campos cubiertos y perder&aacute; todo el progreso si cambia de p&aacute;gina. &iquest;Est&aacute; seguro?</p>', // TRADUCCION
					en: '<p style="text-align: center;">Wait! You have filled fields and you will lose all progress if you change pages. Are you sure?</p>',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			confirmButton: {
				label: '',
				text: {
					es: 'Sí, salir', // TRADUCCION
					en: 'Yes, exit',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			cancelButton: {
				label: '',
				text: {
					es: 'Volver al formulario', // TRADUCCION
					en: 'Return to the form',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
		},
		submitSummary: {
			title: {
				label: '',
				text: {
					es: 'Resumen de su solicitud de asistencia', // TRADUCCION
					en: 'Summary of your request for assistance',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			participantData: {
				label: '',
				text: {
					es: 'Datos del socio', // TRADUCCION
					en: 'Partner details',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			representativeData: {
				label: '',
				text: {
					es: 'Datos del representante', // TRADUCCION
					en: 'Representative details',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			interventions: {
				label: '',
				text: {
					es: 'Intervenciones', // TRADUCCION
					en: 'Interventions',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			attachments: {
				label: 'attachments',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			votes: {
				label: 'votes',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			delegation: {
				label: '',
				text: {
					es: 'Datos del delegado', // TRADUCCION
					en: 'Delegate details',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			confirmButton: {
				label: '',
				text: {
					es: 'Confirmar y enviar', // TRADUCCION
					en: 'Confirm and send',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			cancelButton: {
				label: '',
				text: {
					es: 'Modificar datos', // TRADUCCION
					en: 'Modify data',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			sendingText: {
				label: '',
				text: {
					es: 'Estamos procesando su solicitud. Por favor no cierre la pestaña', // TRADUCCION
					en: 'We are processing your request. Please do not close the tab',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
		},
		submitSuccess: {
			information: {
				label: '',
				text: {
					es: '<p style="text-align: center;"><strong>Su solicitud ha quedado registrada. &iexcl;Gracias!</strong></p><p style="text-align: center;">Recibir&aacute; un correo de confirmaci&oacute;n en las pr&oacute;ximas horas. Revise su bandeja de correo no deseado. Si tras 48h no ha recibido el correo, por favor contacte a trav&eacute;s de Soporte en este portal.</p>', // TRADUCCION
					en: '<p style="text-align: center;"><strong>Your request has been registered. Thanks!</strong></p><p style="text-align: center;">You will receive a confirmation email in the next few hours. Check your spam inbox. If after 48 hours you have not received the email, please contact through Help on this portal.</p>',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			button: {
				label: '',
				text: {
					es: 'Volver al portal', // TRADUCCION
					en: 'Return Home',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
		},
		submitFailure: {
			information: {
				label: '',
				text: {
					es: '<p style="text-align: center;"><strong>Vaya. Algo ha ido mal.</strong></p><p style="text-align: center;">No se ha podido enviar su solicitud. Las razones principales suelen ser una ca&iacute;da del servicio o conectividad desde su equipo. Por favor vuelva a intertarlo en unos minutos y si el problema persiste contacte con nosotros a trav&eacute;s de Soporte.</p>', // TRADUCCION
					en: '<p style="text-align: center;"><strong>Ups. Something has gone wrong.</strong></p><p style="text-align: center;">Your request could not be sent. The main reasons are usually a drop in service or connectivity from your computer. Please try again in a few minutes and if the problem persists contact us through Help.</p>',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
			button: {
				label: '',
				text: {
					es: 'Volver al formulario', // TRADUCCION
					en: 'Return to the form',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				}
			},
		},
	},
	footer: {
		isActive: true,
		copyright: {
			isActive: true,
			label: 'Councilbox Technology S.L.',
			text: {
				es: '',
				en: '',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
			value: 'https://www.councilbox.com',
		},
		links: {
			legalWarning: {
				value: 'https://councilbox.freshdesk.com',
				isActive: true,
				label: 'legal_warning',
				text: {
					es: '',
					en: '',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
			privacyPolicy: {
				value: 'https://councilbox.freshdesk.com',
				isActive: true,
				label: '',
				text: {
					es: 'Política de privacidad', // TRADUCCION
					en: 'Privacy policy',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
			termsConditions: {
				value: 'https://councilbox.freshdesk.com',
				isActive: true,
				label: '',
				text: {
					es: 'Términos y condiciones', // TRADUCCION
					en: 'Terms and conditions',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
			support: {
				value: 'https://councilbox.freshdesk.com',
				isActive: true,
				label: '',
				text: {
					es: 'Soporte', // TRADUCCION
					en: 'Support',
					gal: '',
					cat: '',
					eu: '',
					fr: '',
					pt: '',
					pl: '',
				},
			},
		}
	},
	closedPortal: {
		closeDayFormat: 'DD/MM/YYYY',
		closeHourFormat: 'HH:mm[h]',
		information: {
			label: '',
			text: {
				es: '<p style="text-align: center;"><strong>Las solicitudes para la {{councilName}} de {{companyName}} han sido cerradas con fecha de {{councilCloseDay}} a las {{councilCloseHour}}</strong></p><br><p style="text-align: center;">Por favor contacte directamente con la entidad a trav&eacute;s de su p&aacute;gina web.</p>',
				en: '<p style="text-align: center;"><strong>Applications for the {{councilName}} of Shareholders of {{companyName}} have been closed on {{councilCloseDay}} at {{councilCloseHour}}.</strong></p><br><p style="text-align: center;">Please contact the entity directly through its website.</p>',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
		button: {
			value: 'https://councilbox.freshdesk.com',
			label: '',
			text: {
				es: 'Web de la entidad',
				en: 'Entity website',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
	},
	closedSection: {
		img: 'https://api.dev.councilbox.com/static/img/closedPortal.png',
		intelliTagText: {
			label: '',
			dateFormat: 'DD/MM/YYYY, HH:mm[h]',
			text: {
				es: 'El plazo de solicitud de {{section}} ha finalizado el {{closeDateSection}}',
				en: 'The application deadline for {{section}} ended on {{closeDateSection}}',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		},
		button: {
			value: 'home',
			label: '',
			text: {
				es: 'Volver',
				en: 'Return',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: '',
			},
		},
	},
	loadingScreen: {
		mainImg: 'https://api.dev.councilbox.com/static/img/cbx_logo.png',
		downImg: 'https://api.dev.councilbox.com/static/img/powered_by_cbx.png',
		information: {
			label: '',
			text: {
				es: '<p style="text-align: center;"><em><strong>Est&aacute; siendo dirigido al portal de accionista.</strong></em></p><p style="text-align: center;"><strong><em>No cierre el navegador</em></strong></p>',
				en: '<p style="text-align: center;"><em><strong>You are being directed to the shareholder portal.</strong></em></p><p style="text-align: center;"><strong><em>Don&apos;t close the browser</em></strong></p>',
				gal: '',
				cat: '',
				eu: '',
				fr: '',
				pt: '',
				pl: ''
			}
		}
	},
	optionalFields: {
		access: {
			representation: false,
			delegation: false,
			earlyVote: false,
			interventions: false
		},
		representation: {
			earlyVote: false,
		},
		delegation: {
			earlyVote: false,
		},
		earlyVote: {
		},
		interventions: {
		},
	},
	requiredAttachments: {
		access: [],
		representation: [],
		delegation: [],
		earlyVote: [],
		interventions: []
	},
	attachmentsMaxSize: 20000, // KB
	inputs: {
		access: {
			person: [
				...defaultInput,
			],
			entity: [
				...defaultInput,
			],
			representative: [
				...defaultRepresentativeInput,
			],
			delegate: [
				...defaultDelegateInput
			],
		},
		representation: {
			person: [
				...defaultInput,
			],
			entity: [
				...defaultInput,
			],
			representative: [
				...defaultRepresentativeInput,
			],
			delegate: [
				...defaultDelegateInput
			],
		},
		delegation: {
			person: [
				...defaultInput,
			],
			entity: [
				...defaultInput,
			],
			representative: [
				...defaultRepresentativeInput,
			],
			delegate: [
				...defaultDelegateInput
			],
		},
		earlyVote: {
			person: [
				...defaultInput,
			],
			entity: [
				...defaultInput,
			],
			representative: [
				...defaultRepresentativeInput,
			],
			delegate: [
				...defaultDelegateInput
			],
		},
		interventions: {
			person: [
				...defaultInput,
			],
			entity: [
				...defaultInput,
			],
			representative: [
				...defaultRepresentativeInput,
			],
			delegate: [
				...defaultDelegateInput
			],
		},
	},
	predefinedPeople: {
		representative: {
			access: [],
			representation: [],
			delegation: [],
			earlyVote: [],
			interventions: [],
		},
		delegate: {
			access: [],
			representation: [],
			delegation: [],
			earlyVote: [],
			interventions: [],
		}
	},
	defaultVoteSense: {
		general: null,
		custom: [
			// insert agenda id and default value from it's posible values
		]
	},
	languages: {
		isActive: true,
		default: 'es',
		language: {
			es: {
				valueType: 'text',
				value: 'es',
				label: 'Español',
				text: {},
			},
			en: {
				valueType: 'text',
				value: 'en',
				label: 'English',
				text: {},
			},
		},
	},
	emails: {
		access: {
			internal: {
				for: ['juntas@councilbox.com'],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			},
			external: {
				for: [''],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			}
		},
		delegation: {
			internal: {
				for: ['juntas@councilbox.com'],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			},
			external: {
				for: [''],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			}
		},
		earlyVote: {
			internal: {
				for: ['juntas@councilbox.com'],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			},
			external: {
				for: [''],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			}
		},
		interventions: {
			internal: {
				for: ['juntas@councilbox.com'],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			},
			external: {
				for: [''],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			}
		},
		rejectedRequest: {
			external: {
				for: [''],
				subject: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				},
				body: {
					label: '',
					text: {
						es: '',
						en: '',
						gal: '',
						cat: '',
						eu: '',
						fr: '',
						pt: '',
						pl: '',
					}
				}
			}
		},
	},
	theme: {
		colors: {
			primary: '#154481',
			secondary: '#ffffff',
			light: '#e8ecf2',
			dark: '#0b2241',
			background: '#FFFFFF',
			text: '#154481',
			success: '#61B78A',
			warning: '#F4AB66',
			error: '#DC7575',
			deactivated: '#B4B4B4',
		}
	},
	layout: {
		label: 'layout 1',
		name: 'layout1',
		options: {
			header: 1,
			nav: 1,
			main: 1,
			section: 1,
			footer: 1
		}
	},
	labels: []
};
